export function cmdEnter(submitFunction) {
  return (event) => {
    if (event.keyCode === 13 && (event.metaKey || event.ctrlKey)) {
      return submitFunction(event);
    }
  };
}
